import React, { useState } from "react";

function SideMenu(Props) {
  const { onclick, admin_list } = Props;
  const [selectedElemt, setSelectedElement] = useState(admin_list[0]?.elements || "");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleItemClick = (item) => {
    setSelectedElement(item.elements);
    setIsMenuOpen(false); // Close menu on selection in mobile
    if (onclick) {
      onclick(item.elements, [item.component, item.form]);
    }
  };

  return (
    <>
      {/* Mobile Toggle Button */}
      <div className="d-md-none p-3 bg-white border-bottom d-flex justify-content-between align-items-center sticky-top" style={{ top: "80px", zIndex: 1010 }}>
        <h6 className="m-0 fw-bold">Admin Menu</h6>
        <button 
          className="btn btn-light" 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <i className={`bi ${isMenuOpen ? "bi-x-lg" : "bi-list"} fs-4`}></i>
        </button>
      </div>

      <div
        className={`bg-white border-end shadow-sm side-menu-container ${isMenuOpen ? "open" : ""}`}
        style={{
          height: "calc(100vh - 80px)",
          overflowY: "auto",
          position: "sticky",
          top: "80px",
          padding: "1rem 0.5rem",
          transition: "all 0.3s ease"
        }}
      >
      <div className="px-3 mb-4 mt-2">
        <h6 className="text-uppercase text-muted fw-bold small">Manage Content</h6>
      </div>
      
      <div className="list-group list-group-flush">
        {admin_list &&
          admin_list.map((item) => {
            const isActive = selectedElemt === item.elements;
            return (
              <div
                key={item.elements}
                onClick={() => handleItemClick(item)}
                className={`d-flex align-items-center px-3 py-2 my-1 rounded-3 pointer transition-all ${
                  isActive 
                    ? "text-primary active-item" 
                    : "text-dark hover-bg-light"
                }`}
                style={{ 
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                  backgroundColor: isActive ? "rgba(255, 165, 0, 0.1)" : "transparent"
                }}
              >
                <div 
                  className={`d-flex align-items-center justify-content-center rounded-circle me-3 ${
                    isActive ? "bg-primary-custom text-white" : "bg-light text-secondary"
                  }`}
                  style={{ width: "36px", height: "36px", backgroundColor: isActive ? "var(--primary-color)" : "" }}
                >
                  <i className={`${item.icon} fs-5`}></i>
                </div>
                <span className={`fw-semibold ${isActive ? "text-primary-custom" : "text-muted"}`}>
                  {item.elements}
                </span>
                {isActive && (
                  <div className="ms-auto">
                    <div className="rounded-circle" style={{ width: "6px", height: "6px", backgroundColor: "var(--primary-color)" }}></div>
                  </div>
                )}
              </div>
            );
          })}
      </div>

      <style>{`
        .hover-bg-light:hover {
          background-color: #f8f9fa;
        }
        .text-primary-custom {
          color: var(--primary-color) !important;
        }
        .active-item {
          color: var(--primary-color) !important;
        }
        .pointer {
          cursor: pointer;
        }
        ::-webkit-scrollbar {
          width: 5px;
        }
        ::-webkit-scrollbar-track {
          background: transparent;
        }
        ::-webkit-scrollbar-thumb {
          background: #e0e0e0;
          border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #d0d0d0;
        }

        @media (max-width: 767px) {
          .side-menu-container {
            position: fixed !important;
            top: 130px !important;
            left: 0;
            width: 100%;
            height: auto !important;
            max-height: calc(100vh - 130px);
            z-index: 1005;
            display: none;
            box-shadow: 0 10px 15px rgba(0,0,0,0.1) !important;
          }
          .side-menu-container.open {
            display: block;
          }
        }
      `}</style>
    </div>
    </>
  );
}

export default SideMenu;
